import { QueryClient, type QueryFunctionContext } from '@tanstack/react-query'
import api from '@/shared/utils/axios'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Configure how long data lives in the cache (milliseconds) without other consumers triggering additional requests.
      // Can be configured from 0 to Infinity.
      staleTime: 1000 * 60 * 60, // 1 hour
      // By default, react-query will retry failed requests up to 3 times.
      retry: false,
      retryOnMount: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  },
})

// Utility function that is intended to be used as a `queryFn` for `useQuery` or `useQueries`. It expects to
// receive the request URL from the first element of the query key array and executes the request using our
// configured axios instance.
//
// Usage:
//
// const { data } = useQuery({
//   queryKey: [pointsUrl],
//   queryFn: fetchForUrl<IPoints>,
// })
//
export async function fetchForUrl<T>({ queryKey: [url] }: QueryFunctionContext<string[]>): Promise<T> {
  const result = await api.get<T>(url)
  return result.data
}
